// Utility functions for authentication troubleshooting
import { supabase } from '@/integrations/supabase/client';

export const clearAllAuthStorage = () => {
  console.log('Clearing all authentication storage...');
  
  // Clear localStorage
  const localStorageKeys = Object.keys(localStorage);
  const supabaseLocalKeys = localStorageKeys.filter(key => 
    key.startsWith('sb-yfybcviangjnmdygeiit-') || 
    key.includes('supabase') || 
    key.includes('auth')
  );
  
  supabaseLocalKeys.forEach(key => {
    console.log(`Removing localStorage key: ${key}`);
    localStorage.removeItem(key);
  });
  
  // Clear sessionStorage
  const sessionStorageKeys = Object.keys(sessionStorage);
  const supabaseSessionKeys = sessionStorageKeys.filter(key => 
    key.startsWith('sb-yfybcviangjnmdygeiit-') || 
    key.includes('supabase') || 
    key.includes('auth')
  );
  
  supabaseSessionKeys.forEach(key => {
    console.log(`Removing sessionStorage key: ${key}`);
    sessionStorage.removeItem(key);
  });
  
  console.log('Auth storage cleared successfully');
};

export const debugAuthState = () => {
  console.log('=== AUTH DEBUG INFO ===');
  console.log('LocalStorage keys:', Object.keys(localStorage));
  console.log('SessionStorage keys:', Object.keys(sessionStorage));
  
  // Check for Supabase specific keys
  const supabaseLocalKeys = Object.keys(localStorage).filter(key => 
    key.startsWith('sb-yfybcviangjnmdygeiit-')
  );
  const supabaseSessionKeys = Object.keys(sessionStorage).filter(key => 
    key.startsWith('sb-yfybcviangjnmdygeiit-')
  );
  
  console.log('Supabase localStorage keys:', supabaseLocalKeys);
  console.log('Supabase sessionStorage keys:', supabaseSessionKeys);
  console.log('======================');
};

// Quick validation helper for console debugging
export const debugSupabaseAuth = async () => {
  console.log('🔍 === SUPABASE AUTH DIAGNOSTIC ===');
  
  try {
    
    // 1. Session probe
    const session = await supabase.auth.getSession();
    const user = session.data.session?.user;
    const token = session.data.session?.access_token;
    
    console.log('📱 Session:', {
      hasUser: !!user,
      userId: user?.id,
      isAnonymous: user?.is_anonymous,
      hasToken: !!token,
      tokenPreview: token ? `${token.substring(0, 10)}...` : 'None'
    });
    
    // 2. RPC probe
    try {
      const { data: rpcResult, error: rpcError } = await supabase.rpc('debug_auth_uid');
      console.log('🔐 RLS Auth UID:', rpcError ? `Error: ${rpcError.message}` : rpcResult);
    } catch (e) {
      console.log('🔐 RLS Auth UID: Exception -', e);
    }
    
    // 3. Protected table probe
    if (user) {
      try {
        const { data: profileData, error: profileError } = await supabase
          .from('profiles')
          .select('id')
          .eq('id', user.id)
          .single();
        
        console.log('🛡️ Profile Access:', profileError ? 
          `Error: ${profileError.message}` : 
          profileData ? '✅ Success' : '❌ No data'
        );
      } catch (e) {
        console.log('🛡️ Profile Access: Exception -', e);
      }
    } else {
      console.log('🛡️ Profile Access: Skipped (no user)');
    }
    
  } catch (error) {
    console.error('❌ Diagnostic failed:', error);
  }
  
  console.log('=================================');
};

// Add this to window for debugging in browser console
if (typeof window !== 'undefined') {
  (window as any).clearAllAuthStorage = clearAllAuthStorage;
  (window as any).debugAuthState = debugAuthState;
  (window as any).debugSupabaseAuth = debugSupabaseAuth;
}